export default __webpack_public_path__ + "static/media/category-63.e3837fa6.svg";